import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=bf24e570&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf24e570",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf24e570')) {
      api.createRecord('bf24e570', component.options)
    } else {
      api.reload('bf24e570', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=bf24e570&scoped=true&", function () {
      api.rerender('bf24e570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8nBPJ0poyi4xR/JS/comp/Accordion.vue"
export default component.exports